import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuthStore } from '../../stores/useAuthStore';
import { useSocketStore } from '../../stores/useSocketStore';
import { showNotificationToast } from '../../utils/ShowNotificationToast';

function GlobalNotificationManager() {
  const location = useLocation();
  const locationRef = useRef(location);
  const user = useAuthStore((state) => state.user);

  const receivedPersonalMessage = useSocketStore(
    (state) => state.receivedPersonalMessage
  );
  const receivedGroupMessage = useSocketStore(
    (state) => state.receivedGroupMessage
  );
  // const receivedSystemMessage = useSocketStore(
  //   (state) => state.receivedSystemMessage
  // );

  useEffect(() => {
    locationRef.current = location;
  }, [location]);

  // Show toast for personal messages if chat is not open
  useEffect(() => {
    if (!receivedPersonalMessage) return;
    const currentPath = locationRef.current.pathname;
    const isChatOpen = currentPath.includes(
      `/message/personal/${receivedPersonalMessage.senderId}`
    );
    if (!isChatOpen && user?.uid && receivedPersonalMessage.senderId !== user.uid) {
      showNotificationToast(receivedPersonalMessage, 'personal');
    }
  }, [receivedPersonalMessage, user?.uid]);

  // Show toast for group messages if group chat is not open
  useEffect(() => {
    if (!receivedGroupMessage) return;
    const currentPath = locationRef.current.pathname;
    const isChatOpen = currentPath.includes(
      `/message/groups/${receivedGroupMessage.chatGroupId}`
    );

    if (!isChatOpen && user?.uid && receivedGroupMessage.senderId !== user.uid) {
      showNotificationToast(receivedGroupMessage, 'group');
    }
  }, [receivedGroupMessage, user?.uid]);

  // Show toast for system messages
  // Currently not using any system messages
  // useEffect(() => {
  //   if (!receivedSystemMessage) return;

  //   showNotificationToast(receivedSystemMessage, 'system');
  // }, [receivedSystemMessage]);

  return null;
}

export default GlobalNotificationManager;
